import React from 'react'
import Case from './Case'
import caseImg1 from '../img/cases/case_img1.svg'
import caseImg2 from '../img/cases/case_img2.svg'
import caseImg3 from '../img/cases/case_img3.svg'
import caseImg4 from '../img/cases/case_img4.svg'

const casesList = [
  { id: 1, img: caseImg1, title: 'Securing Unich: Softstack’s Smart Contract Audit for OTC Trading', text: 'Softstack audited Unich’s OTC smart contracts on EVM & Solana, resolving security risks and optimizing efficiency. Learn how Unich improved its security in our full report.' },
  { id: 2, img: caseImg2, title: 'Securing Unich: Softstack’s Smart Contract Audit for OTC Trading', text: 'Softstack audited Unich’s OTC smart contracts on EVM & Solana, resolving security risks and optimizing efficiency. Learn how Unich improved its security in our full report.' },
  { id: 3, img: caseImg3, title: 'Securing Unich: Softstack’s Smart Contract Audit for OTC Trading', text: 'Softstack audited Unich’s OTC smart contracts on EVM & Solana, resolving security risks and optimizing efficiency. Learn how Unich improved its security in our full report.' },
  { id: 4, img: caseImg4, title: 'Securing Unich: Softstack’s Smart Contract Audit for OTC Trading', text: 'Softstack audited Unich’s OTC smart contracts on EVM & Solana, resolving security risks and optimizing efficiency. Learn how Unich improved its security in our full report.' },
  { id: 5, img: caseImg1, title: 'Securing Unich: Softstack’s Smart Contract Audit for OTC Trading', text: 'Softstack audited Unich’s OTC smart contracts on EVM & Solana, resolving security risks and optimizing efficiency. Learn how Unich improved its security in our full report.' }
];

export default function Cases() {
  
  
  return (
    <div className='cases'>
      {/* <div className='cases-spotlight'></div> */}
      <div className='container'>
        <div className='cases-title'>
            <h2>We don’t just develop Web3 solutions — we create <span className='hero-title-end'>successful products</span></h2>
            <p>Each case in our portfolio demonstrates how we solve our clients’ specific challenges: from smart contract audits and enhanced security to building scalable ecosystems.</p>
        </div>
        <div className='cases-list'>
            {casesList.map((item) => (
                <Case key={item.id} id={item.id} img={item.img} title={item.title} text={item.text}/>
            ))}
        </div>
        <div className='cases-btn'>
          <a href='#'>See all</a>
        </div>
      </div>
    </div>
  )
}
